import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as api from '../../services/price_group/api_price_group';
import * as apiCommon from '../../services/apiCommon';
import {
  showProgressListTable,
  doneListTable,
  showErrorListTable,
  doneSaveRecord,
  showErrorSaveRecord,
  doneDataById,
  showProgressDeleteRecord,
  showErrorDeleteRecord,
  showProgressDataById,
  showErrorDataById,
  doneDeleteRecord,
  showProgressSaveRecord
} from '../sagasCommon';
import { PRICE_GROUP } from '../../constants/constant_doc_types';
import { SIMPLE_FORM_SET_DATA } from '../../constants/constant_saga_types';

export function* fetchListPriceGroupSaga(feathersApp) {
  yield takeLatest(
    'FETCH_LIST_PRICE_GROUP',
    callFetchListPriceGroup,
    feathersApp
  );
}

function* callFetchListPriceGroup(feathersApp, action) {
  const { silent, filters } = action;
  yield showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: PRICE_GROUP,
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield showErrorListTable(error);
  }
}

export function* savePriceGroupSaga(feathersApp) {
  yield takeEvery('SAVE_PRICE_GROUP', callSavePriceGroup, feathersApp);
}

function* callSavePriceGroup(feathersApp, action) {
  const { tenant, user } = yield select();
  try {
    yield showProgressSaveRecord();

    const params = { tenant, user, data: action.data };
    const result = yield call(api.savePriceGroup, feathersApp, params);

    yield doneSaveRecord(result, 'Price group was saved');
    yield put({ type: SIMPLE_FORM_SET_DATA, data: result });
    yield callFetchListPriceGroup(feathersApp, { silent: true });
  } catch (e) {
    yield showErrorSaveRecord(e);
  }
}

export function* deletePriceGroupFromListSaga(feathersApp) {
  yield takeEvery(
    'DELETE_PRICE_GROUP_FROM_LIST',
    callDeletePriceGroupFromList,
    feathersApp
  );
}

function* callDeletePriceGroupFromList(feathersApp, action) {
  yield deletePriceGroup(feathersApp, action);
  yield delay(2000);
  yield callFetchListPriceGroup(feathersApp, { silent: true });
}

function* deletePriceGroup(feathersApp, action) {
  yield showProgressDeleteRecord();
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const params = { tenant, user, id };
      result = yield call(api.deletePriceGroup, feathersApp, params);
      yield doneDeleteRecord(id, PRICE_GROUP);
      yield callFetchListPriceGroup(feathersApp, { silent: true });
    }
    return result;
  } catch (error) {
    yield showErrorDeleteRecord(error);
  }
}

export function* deletePriceGroupSaga(feathersApp) {
  yield takeEvery('DELETE_PRICE_GROUP', callDeletePriceGroup, feathersApp);
}

function* callDeletePriceGroup(feathersApp, action) {
  const result = yield deletePriceGroup(feathersApp, action);
  yield delay(2000);
  if (result) {
    browserHistory.push('/admin/price_group');
  }
}

export function* fetchPriceGroupForEditSaga(feathersApp) {
  yield takeEvery(
    'FETCH_PRICE_GROUP_BY_ID',
    callFetchPriceGroupForEdit,
    feathersApp
  );
}

function* callFetchPriceGroupForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id } = action;
  try {
    if (id) {
      yield showProgressDataById();
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchPriceGroupById, feathersApp, fetchParams);
      yield doneDataById(doc);
      yield put({
        type: SIMPLE_FORM_SET_DATA,
        data: doc,
      });
    }
  } catch (error) {
    yield showErrorDataById(error);
  }
}
